(function($){
    $('body').on('click', '.check-all-payment-agreements input', function(){
        $('.custom-agreement input').prop('checked', $(this).prop('checked'));
    })
})(jQuery)